// extracted by mini-css-extract-plugin
export default {"message":"message_message__fAOA7","error":"message_error__5RnBl","success":"message_success__jEEDt"};